import { atom } from 'recoil';
import { Translation } from '../../domain/Translation';

export const translationsState = atom<Translation[]>({
  key: 'translationsState',
  default: [],
});
